// import LocalStorage from 'utils/cognito/storage.web';
// import { StorageKeys } from 'utils/local-storage';

// import { isChaosModeEnabled } from './chaos-mode';

// const enableDebugOperationName = __DEV__ || LocalStorage.getItem(StorageKeys.DEBUG_OPERATION_NAME);

const enableCustomFetch = false;

export const operationNameTraceFetchOptions = enableCustomFetch
  ? {
      fetch: async (url: string, options?: RequestInit) => {
        const finalUrl = operationNameTraceUrl(new URL(url), options?.body as string);
        return fetch(finalUrl, options);
      },
    }
  : null;

export const operationNameTraceUrl = (url: URL, jsonBody: string) => {
  if (!enableCustomFetch) {
    return url;
  }

  let finalUri = url;
  try {
    const { operationName } = JSON.parse(jsonBody);
    if (operationName) {
      url.searchParams.append('operationName', operationName);
      url.searchParams.append('requestHash', fnv32a(jsonBody).toString());
      finalUri = url;
    }
  } catch (_error) {}

  return finalUri;
};

// simple hash function
function fnv32a(str: string) {
  let hval = 0x811c9dc5;
  for (let i = 0; i < str.length; ++i) {
    hval ^= str.charCodeAt(i);
    hval += (hval << 1) + (hval << 4) + (hval << 7) + (hval << 8) + (hval << 24);
  }
  return hval >>> 0;
}
